import apiClient from 'apiClient';
import { AddressResponse } from 'shared/interface/globalInterface';

export const fetchAddresses = (postcode: string): Promise<AddressResponse[]> => {
  return apiClient.get(`/api/v1/core/address-details/${postcode}`).then((res) => {
    return res.data;
  });
};
